import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@core-ui/Components/ui/dialog';
import { Button } from '@core-ui/Components/ui/button';

import type { ScriptType } from '../types/wizard.types';

interface IntentPreviewModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  intent: ScriptType | null;
}

export default function IntentPreviewModal ({
  isOpen,
  onOpenChange,
  intent,
}: IntentPreviewModalProps): React.JSX.Element {
  const { t } = useTranslation();

  const getLanguageBadge = (body: string): string => {
    const spanishPattern = /hola|buenos|gracias|llamando|nombre/i;
    return spanishPattern.test(body) ? 'ES' : 'EN';
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] rounded-2xl shadow-2xl bg-card text-foreground border border-border">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold">{intent?.title ?? ''}</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="rounded-lg border border-border bg-muted/50 p-4 break-all max-h-[60vh] overflow-y-scroll">
            <div className="text-sm whitespace-pre-wrap leading-relaxed">
              {intent?.body}
            </div>
          </div>

          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <span>{t('wizard.intentPreview.language')}: {intent !== null ? getLanguageBadge(intent.body) : '-'}</span>
            <span>·</span>
            <span>{t('wizard.selectIntent.updated')} {intent?.updatedAt !== undefined ? new Date(intent.updatedAt).toLocaleDateString() : '-'}</span>
          </div>
        </div>

        <div className="flex items-center justify-between pt-4">
          <div className="text-sm text-muted-foreground">
            {intent?.body.length ?? 0} {t('wizard.intentPreview.characters')}
          </div>
          <Button
            onClick={() => {
              onOpenChange(false);
            }}
          >
            {t('wizard.intentPreview.close')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
